import React from "react";
import { Input } from "@cadmakers-ui/core";
import styles from "./CheckItem.module.scss";

type CheckItemProps = {
  checked?: boolean;
  indeterminate?: boolean;
  label: string;
  onChange: (index: number) => void;
  index: number;
  key: number | string;
};

export const OverviewCheckItem: React.FC<CheckItemProps> = ({
  checked,
  indeterminate,
  label,
  onChange,
  index,
  key
}) => {
  return (
    <div className={styles["check-item"]}>
      <Input
        id={`custom-check-box-${index}`}
        value={key}
        type="checkbox"
        checked={checked}
        customOption={{ small: true, indeterminate }}
        onChange={() => onChange(index)}
        translate
      />
      <span>{label}</span>
    </div>
  );
};
